"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Helion = void 0;
var Card_1 = require("../Card");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var Helion = (function (_super) {
    __extends(Helion, _super);
    function Helion() {
        return _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.HELION,
            tags: [Tags_1.Tags.SPACE],
            startingMegaCredits: 42,
            metadata: {
                cardNumber: 'R18',
                description: 'You start with 3 heat production and 42 M€.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.br;
                    b.production(function (pb) { return pb.heat(3); }).nbsp.megacredits(42);
                    b.corpBox('effect', function (ce) {
                        ce.effect('You may use heat as MC. You may not use M€ as heat.', function (eb) {
                            eb.startEffect.text('x').heat(1).equals().megacredits(0).multiplier;
                        });
                    });
                }),
            },
        }) || this;
    }
    Helion.prototype.play = function (player) {
        player.canUseHeatAsMegaCredits = true;
        player.addProduction(Resources_1.Resources.HEAT, 3);
        return undefined;
    };
    return Helion;
}(Card_1.Card));
exports.Helion = Helion;
//# sourceMappingURL=Helion.js.map